export const Images: { [key: string]: string } = {
  iconChingariLogo: `/assets/images/astro-logo.png`,
  iconChingariFireLogo: `/assets/images/astro-icon.png`,
};
